import {BaseService} from "./base.service";

class PlaceOfCareService extends BaseService {
    constructor() {
        super('api/place-of-cares');
    }
}

export const placeofcaresService = new PlaceOfCareService();
